let calls = 0
let prevTimestamp = new Date().toISOString()

export const getUniqueCurrentISOTimestamp = (): string => {
  const newTimestamp = new Date().toISOString()
  if (newTimestamp !== prevTimestamp) {
    calls = 0
    prevTimestamp = newTimestamp
  }
  const paddedCall = `${(calls += 1 % 1000)}`.padStart(3, '0')
  return newTimestamp.replace(/(\.\d+)/, `$1${paddedCall}`)
}
